import { DiscountBrandType } from "src/Modules/Discounts/types";
import { RCItemType } from "src/types/RCItemType";
import BaseApi from "src/store/apis/BaseApi";
const PrivateAPIWithTags = BaseApi.enhanceEndpoints({
  addTagTypes: ["userDetails"],
});

type ResponseType<T> = {
  message: string;
  errorCode: 0;
  referenceId: string;
  result: T;
  data:T;
};

export const PointsExchangeApi = PrivateAPIWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getDestinations: builder.query<DiscountBrandType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `/v1.0/Item/WithDetails`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response?.result?.data;
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getSingleDestination: builder.query<RCItemType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `/v1.0/item/Details`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response?.result?.data;
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    checkout: builder.mutation<any,any>({
      query: (body) => {
        return {
          url: `/Order/Checkout`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response?.result;
      },
      invalidatesTags:["userDetails"],
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
  }),
});

type PointsExhangeEndpoints = keyof typeof PointsExchangeApi.endpoints;
export { type PointsExhangeEndpoints };
export const { useGetDestinationsQuery, useCheckoutMutation, useGetSingleDestinationQuery } = PointsExchangeApi;
